module.exports = __webpack_public_path__ + "img/Trash-icon.8ffe1b2e.svg";